export default "__VITE_ASSET__eb52b384__"